import { Entry } from "contentful";

import SkeletonProductTile from "~/components/common/skeletons/skeleton-product-tile";
import { CarouselWrapper } from "~/components/editorials/carousel-utils/carousel-utils";
import Editorials from "~/types/editorials";
import Constants from "~/utils/constants";

import styles from "./skeleton-carousel.module.scss";

type Props = {
  entry?: Entry<Editorials.ProductCarousel>;
};

export default function SkeletonCarousel(props: Props) {
  return (
    <CarouselWrapper entry={props.entry}>
      <div className={styles.carousel}>
        {Array.from({ length: Constants.MAX_PRODUCTS_LOADED_IN_CAROUSEL }).map((_, i) => (
          <div key={"skeleton-slide-" + i} className={styles.initialSlide}>
            <SkeletonProductTile />
          </div>
        ))}
      </div>
    </CarouselWrapper>
  );
}
